// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMessage-moduleassistant__rMhNI";
var _2 = "GretaAIChatMessage-modulebubble__e5dLk";
var _3 = "GretaAIChatMessage-modulecontent__wiq1h";
var _4 = "GretaAIChatMessage-modulemessage__W08Kp";
var _5 = "GretaAIChatMessage-moduletoolbarPinned__Ala8B";
var _6 = "GretaAIChatMessage-moduleuser__uXLx2";
export { _1 as "assistant", _2 as "bubble", _3 as "content", _4 as "message", _5 as "toolbarPinned", _6 as "user" }
